import { TabType } from '../../../__generated__/queries-web';
import { DEFAULT_CATEGORY_FORM_SECTION } from '../constants';
import type {
  CategoryFormSectionBoardQualifier,
  CategoryFormSectionBoardTag,
  Section,
  SectionForm,
  SectionTabQualifier,
  SectionTabTag,
} from '../views/Edit/components/Section/types';
import { getSectionFormContent } from '../views/Edit/components/Section/utils';

const getBoardTabTags = (
  tags: SectionTabTag[] | undefined,
): CategoryFormSectionBoardTag[] =>
  tags?.map(({ tag }) => ({
    id: tag.id,
    title: tag.title,
  })) ?? [];

const getBoardTabQualifiers = (
  qualifiers: SectionTabQualifier[] | undefined,
): CategoryFormSectionBoardQualifier[] =>
  qualifiers?.map(({ qualifier }) => ({
    id: qualifier.id,
    title: qualifier.title,
  })) ?? [];

export const getCategoryFormSection = ({
  content,
  createdAt,
  description,
  id,
  isOnline,
  order,
  title,
  type,
  metas,
  tags,
  qualifiers,
}: Section & { createdAt?: string }): SectionForm => {
  let parsedContent;

  try {
    parsedContent = content ? content : getSectionFormContent(type);
  } catch (e) {
    parsedContent = getSectionFormContent(type);
  }

  const baseSection = {
    content: parsedContent,
    ...(createdAt && { createdAt }),
    description: description || DEFAULT_CATEGORY_FORM_SECTION.description,
    id,
    isActive: isOnline || DEFAULT_CATEGORY_FORM_SECTION.isActive,
    order,
    title,
    type,
    metas: metas || DEFAULT_CATEGORY_FORM_SECTION.metas,
  };

  if (type !== TabType.Board) {
    return baseSection as SectionForm;
  }

  return {
    ...baseSection,
    qualifiers: getBoardTabQualifiers(qualifiers),
    tags: getBoardTabTags(tags),
  } as SectionForm;
};
